export default __webpack_public_path__ + "static/media/09.d4ebbe4b.jpg";